const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/

function idOf(item) {
  return String(item?.id ?? item?.routeId ?? '').trim()
}

function hasText(value) {
  return String(value ?? '').trim().length > 0
}

function findDuplicates(items, getId = idOf) {
  const seen = new Set()
  const dupes = new Set()
  for (const item of items ?? []) {
    const id = getId(item)
    if (!id) continue
    if (seen.has(id)) dupes.add(id)
    seen.add(id)
  }
  return [...dupes]
}

export function validateShuttleData(data = {}) {
  const stops = Array.isArray(data.stops) ? data.stops : []
  const routes = Array.isArray(data.routes) ? data.routes : []
  const schedules = Array.isArray(data.schedules) ? data.schedules : []
  const errors = []
  const warnings = []

  if (stops.length === 0) warnings.push('정류장 데이터가 비어 있습니다.')
  if (routes.length === 0) warnings.push('노선 데이터가 비어 있습니다.')
  if (schedules.length === 0) warnings.push('시간표 데이터가 비어 있습니다.')

  for (const id of findDuplicates(stops)) errors.push(`정류장 id 중복: ${id}`)
  for (const id of findDuplicates(routes)) errors.push(`노선 id 중복: ${id}`)

  const stopIds = new Set(stops.map(idOf).filter(Boolean))
  const routeIds = new Set(routes.map(idOf).filter(Boolean))

  stops.forEach((stop, index) => {
    const id = idOf(stop)
    if (!id) errors.push(`정류장 ${index + 1}: id가 비어 있습니다.`)
    if (!hasText(stop.name)) errors.push(`정류장 ${id || index + 1}: name이 비어 있습니다.`)
    if (stop.active === false) return
    const lat = Number(stop.lat)
    const lng = Number(stop.lng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) errors.push(`정류장 ${id || index + 1}: lat/lng는 숫자여야 합니다.`)
  })

  routes.forEach((route, index) => {
    const id = idOf(route)
    if (!id) errors.push(`노선 ${index + 1}: id가 비어 있습니다.`)
    if (!hasText(route.name)) errors.push(`노선 ${id || index + 1}: name이 비어 있습니다.`)
    if (!Array.isArray(route.stopIds) || route.stopIds.length === 0) {
      errors.push(`노선 ${id || index + 1}: stopIds가 비어 있습니다.`)
      return
    }
    route.stopIds.forEach(stopId => {
      if (!stopIds.has(String(stopId))) errors.push(`노선 ${id}: 존재하지 않는 정류장 참조 ${stopId}`)
    })
  })

  schedules.forEach((schedule, index) => {
    const routeId = String(schedule.routeId ?? '').trim()
    const label = routeId || index + 1
    if (!routeId) errors.push(`시간표 ${index + 1}: routeId가 비어 있습니다.`)
    else if (!routeIds.has(routeId)) errors.push(`시간표 ${index + 1}: 존재하지 않는 노선 참조 ${routeId}`)
    if (!TIME_RE.test(String(schedule.departureTime ?? ''))) errors.push(`시간표 ${label}: departureTime은 HH:mm 형식이어야 합니다.`)
    if (schedule.days != null && !Array.isArray(schedule.days)) errors.push(`시간표 ${label}: days는 배열이어야 합니다.`)
  })

  return {
    ok: errors.length === 0,
    errors,
    warnings,
    counts: { stops: stops.length, routes: routes.length, schedules: schedules.length },
  }
}

export function assertValidShuttleData(data) {
  const result = validateShuttleData(data)
  if (!result.ok) {
    const err = new Error(result.errors.join('\n'))
    err.validation = result
    throw err
  }
  return result
}
